<div class="waiting-room-header">
  <div class="waiting-room-logo">
    <img src="assets/img/diseno/logo.png" />
  </div>
  <!-- SUPPORT PHONE -->
  <div class="waiting-room-support">
    <!-- SUPPORT DESKTOP -->
    <div class="content">
      <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
      <p class="number">{{supportPhone}}</p>
    </div>
    <div class="icon-desktop">
      <i class="icon-call_blue"></i>
    </div>
     <!-- BOTTON MOBILE SUPPORT MOBILE -->
    <div class="support-mobile-btn more-btn">			
      <div class="suppor-icon" (click)="showSupportNumber()">
        <i class="icon-call_blue"></i>
        <p class="text" [translate]="'HEADER.TECHNICAL_SUPPORT'"></p>
      </div>     
      <!-- CONTAINER TELÉFONO SOPORTE TOOLTIP -->
      <div class="support-number-container box-content">
        <sas-support-tooltip></sas-support-tooltip>
      </div>
      <!-- @if(!hide){
              <div class="box-content" >
                <p class="text"  translate="HEADER.TECHNICAL_SUPPORT"></p>
                <a href="tel:+{{supportPhone}}" class="number">{{supportPhone}}</a>
              </div>
            } -->
    </div>
  </div>
</div>

<div class="overlay-container">
  <div class="overlay-container-left">

    @if(reason !== disconnectedStatus.NOT_FOUND){
      <!-- MENSAJES DE SALA DE ESPERA -->
      <div>
        <h1 class="title">{{ 'DISCONNECTED.GREETING' | translate }} {{ mySelf }} </h1>
        <h1><span class="fw-normal" [translate]="'DISCONNECTED.NOT_FOUND.TITLE'"></span></h1>
      </div>
    }

    @if(reason === disconnectedStatus.NOT_FOUND){
      <!-- TÍTULO ERROR 404 -->
      <div>
        <h1 class="title" [translate]="'ERROR.TITLE1'"></h1>
        <h1><span class="fw-normal" [translate]="'ERROR.TITLE2'"></span></h1>
      </div>
    }

    @if(reason === disconnectedStatus.OVER){
      <!-- CONTAINER MENSAJE TU SESIÓN HA EXPIRADO -->
      <div class="overlay-info-container">
        <div class="u-flex u-flex-column date-is-over">
          <div class="date-headline u-divider-bottom-xl" [translate]="'DISCONNECTED.OVER.TITLE'"></div>
          <div class="u-flex u-flex-align-items-center u-divider-bottom-xl">
            <i class="icon-clock"> </i>
            <div class="u-divider-left" [translate]="'DISCONNECTED.OVER.TEXT'">
            </div>
          </div>
        </div>
      </div>
    }

    @if(reason === disconnectedStatus.NOT_STARTED){
      <div class="wrapper-overlay-info-container" >
        <div class="overlay-info-container">
          <div class="u-flex u-flex-column date-to-start">
            <div class="date-headline u-divider-bottom-xl" [translate]="'DISCONNECTED.NOT_STARTED.TITLE'"></div>
            <div class="u-flex u-divider-bottom-xl">
              <i class="icon-clock"> </i>
              <div class="u-flex u-flex-column u-divider-left">
                <div class="date-time">
                  {{startDate.hour}}:{{startDate.minute}}
                </div>
                <div class="date-day">
                  {{startDate.day}} {{'UTILS.OF' | translate}} {{'MONTHS.' + startDate.month | translate}}
                  {{'UTILS.OF' | translate}} {{startDate.year}}
                </div>
              </div>
            </div>
          </div>
        </div>
        @if(roleType === ROLES_TYPE.USER_SHORT){
          <!-- AÑADIR CLASE .participant-text PARA INTRODUCIR EL NOMBRE DEL DOCTOR O DEL PACIENTE -->
          <h1 class="participant-text">
            <span class="fw-normal" [translate]="'DISCONNECTED.NAME_TEXT.AMPHITRYON'"
              [translateParams]="{ name: participantsNames[ROLES_TYPE.AMPHITRYON_SHORT] }"></span>
          </h1>
        }
        @if(roleType === ROLES_TYPE.AMPHITRYON_SHORT){
          <h1 class="participant-text">
            <span class="fw-normal"
              [translate]="otherParticipants.length === 1 ? 'DISCONNECTED.NAME_TEXT.USER' : 'DISCONNECTED.NAME_TEXT.USERS'"
              [translateParams]="{ name: participantsNames[ROLES_TYPE.USER_SHORT] }"></span>
          </h1>
        }
      </div>
    }
    <!-- CONTAINER MENSAJE "TU CITA ESTÁ PROGRAMADA" -->

    @if(reason === disconnectedStatus.HUNG_UP){
      <!-- CONTAINER DESCONEXIÓN -->
      <div>
        <div class="overlay-info-container pointer" (click)="reconnect()">
          <div class="date-disconected u-flex u-flex-column">
            <div class="date-greeting" [translate]="'DISCONNECTED.HUNG_UP.TITLE'"></div>
            <div class="u-flex u-flex-align-items-center u-divider-bottom-xl">
              <i class="icon-phone-on"> </i>
              <div class="date-txt u-divider-left" [translate]="'DISCONNECTED.HUNG_UP.BUTTON'"></div>
            </div>
            <div class="date-headline" [translate]="'DISCONNECTED.HUNG_UP.TEXT'"></div>
          </div>
        </div>
        <!-- AÑADIR CLASE .participant-text PARA INTRODUCIR EL NOMBRE DEL DOCTOR O DEL PACIENTE -->
      </div>
    }

    @if(reason === disconnectedStatus.NOT_FOUND){
      <!-- CONTAINER ERROR 404 -->
      <div class="overlay-info-container">
        <div class="u-flex u-flex-column date-is-over">
          <div class="date-greeting" [translate]="'ERROR.TITLE1'"></div>
          <div class="date-headline u-divider-bottom-xl" [translate]="'ERROR.SUBTITLE'"></div>
          <div class="u-flex u-flex-align-items-center u-divider-bottom-xl">
            <i class="icon-clock"> </i>
            <div class="u-divider-left" [translate]="'ERROR.TEXT'">
            </div>
          </div>
        </div>
      </div>
    }

    @if(pinRequiered && reason === disconnectedStatus.PASSWORD_REQUIRED){
      <!-- CONTAINER PASSWORD -->
      <div class="wrapper-overlay-info-container">
        <div class="overlay-info-container">
          <div class="u-flex u-flex-column date-to-start">
            <div class="date-headline u-divider-bottom u-weight-500" [translate]="'DISCONNECTED.PASSWORD.TITLE'"></div>
            @if(signInForm){
              <form class="u-flex u-flex-align-items-end u-divider-bottom-xl" [formGroup]="signInForm">
                <div class="form-group u-width-100">
                  <label for="pass" [translate]="'DISCONNECTED.PASSWORD.INPUT_TEXT'"></label>
                  <!-- AÑADIR CLASE .invalid PARA ESTILOS EN ROJO -->
                  <input class="form-control invalid" formControlName="password" type=" " id="pass" name="pass" min="10"
                    max="100"
                    [ngClass]="{ 'invalid': signInForm.controls['password'].invalid && signInForm.controls['password'].touched ||invalidPassword }">
                    @if(signInForm.controls['password'].invalid && signInForm.controls['password'].touched || invalidPassword){

                      <span class="validation-text"
                      
                      [translate]="'DISCONNECTED.PASSWORD.INVALID_PASSWORD'">
                      </span>
                    }
                </div>
                <button class="btn btn-primary" type="submit" [translate]="'DISCONNECTED.PASSWORD.BUTTON_TEXT'"
                  (click)="sendPassword()"></button>
              </form>
            }
          </div>
        </div>
        @if(roleType === ROLES_TYPE.USER_SHORT){
          <!-- AÑADIR CLASE .participant-text PARA INTRODUCIR EL NOMBRE DEL DOCTOR O DEL PACIENTE -->
          <h1 class="participant-text">
            <span class="fw-normal" [translate]="'DISCONNECTED.NAME_TEXT.AMPHITRYON'"
              [translateParams]="{ name: participantsNames[ROLES_TYPE.AMPHITRYON_SHORT] }"></span>
          </h1>
        }
        @if(roleType === ROLES_TYPE.AMPHITRYON_SHORT){
          <h1 class="participant-text">
            <span class="fw-normal"
              [translate]="otherParticipants.length === 1 ? 'DISCONNECTED.NAME_TEXT.USER' : 'DISCONNECTED.NAME_TEXT.USERS'"
              [translateParams]="{ name: participantsNames[ROLES_TYPE.USER_SHORT] }"></span>
          </h1>
        }
      </div>
    }


    @if(!isPatient && surveyDone !== true && reason === disconnectedStatus.HUNG_UP && enabledSurvey){
      <!-- CONTAINER VALORACIÓN -->
      <div class="overlay-info-container pointer"
        (click)="goToSurvey()">
        <div class="u-flex u-flex-column date-disconected">
          <div class="date-greeting" [translate]="'DISCONNECTED.SURVEY.TITLE'"></div>
          <div class="u-flex u-flex-align-items-center u-divider-bottom-lg">
            <i class="icon-emoji-ok-off"> </i>
            <div class="date-txt u-divider-left" [translate]="'DISCONNECTED.SURVEY.ACTION'"></div>
          </div>
          <div class="date-headline" [translate]="'DISCONNECTED.SURVEY.TEXT'"></div>
        </div>
      </div>
    }

    @if(reason === disconnectedStatus.WAITING){
      <!-- CONTAINER WAITING -->
      <div class="overlay-info-container" >
        <div class="u-flex u-flex-column date-disconected">
          <div class="date-headline" [translate]="'DISCONNECTED.WAITING.TEXT'"></div>
        </div>
      </div>
    }

    @if(reason === disconnectedStatus.START){     
      <!-- CONTAINER START -->
      <div class="overlay-info-container pointer">
        <div class="u-flex u-flex-column date-disconected">
          <div class="date-headline" [translate]="'DISCONNECTED.TEST.TEST'"></div>
        </div>
      </div>
    }

    @if((surveyDone && reason === disconnectedStatus.HUNG_UP && roomData?.activeSurvey) || (roomData?.surveyAnswered && roomData?.activeSurvey)){
      <!-- MESSAGE "GRACIAS POR SU COLABORACIÓN" -->
      <div
        class="overlay-info-container message message-ok">
        <i class="icon-check"></i>
        <div class="u-divider-top-xl" [translate]="'DISCONNECTED.THANKS.MSG'">
        </div>
      </div>
    }

  </div>

  @if(reason !== disconnectedStatus.OVER && reason !== disconnectedStatus.NOT_FOUND){
    <div class="overlay-container-right">
  
      <div class="overlay-info-container">
        <!-- CONFIGURACIÓN GENERAL -->
        <div class="all-settings">
          <!-- imagen camara -->
          <div class="overlay-info-container-video">
            <div class="publisher-container" [ngClass]="{'publishing': publishing}" #publisherDiv>
            </div>
          </div>
  
          <div class="overlay-info-setting">
            <div class="overlay-setting-item">
              <div class="overlay-setting-icon">
                <i class="icon-camera"></i>
              </div>
              <div class="overlay-setting-txt" [translate]="'DISCONNECTED.TEST.CAMERA'"></div>
              <div class="toggle-container">
                <label class="switch">
                  <input id="cameraTest" type="checkbox" (change)="changeCamera($event)"
                    [checked]="videoEnabled$ | async">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <div class="overlay-setting-item">
              <div class="overlay-setting-icon">
                <i class="icon-mic"></i>
              </div>
              <div class="u-flex u-flex-column overlay-setting-txt">
                <div [translate]="'DISCONNECTED.TEST.MIC'"></div>
                <meter id="publisherMeter" min="0" max="1" value="0"></meter>
              </div>
              <div class="toggle-container">
                <label class="switch">
                  <input type="checkbox" (change)="changeMicro($event)" [checked]="audioEnabled$ | async">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
  
      </div>
  
      @if(devicesTestActivate){
        <!-- TEST CONTAINER DESKTOP -->
        <div class="overlay-info-container test-container">
          <div class="u-flex u-flex-justify-content-between u-divider-bottom-sm">
            <div class="u-flex u-flex-align-items-center test-container-item">
              <div [translate]="'DISCONNECTED.TEST.VIDEO'">
              </div>
              <i class="icon-check"></i>
            </div>
            <div class="u-flex u-flex-align-items-center test-container-item">
              <div [translate]="'DISCONNECTED.TEST.AUDIO'"></div>
              <i class="icon-check"></i>
            </div>
            <div class="u-flex u-flex-align-items-center test-container-item">
              <div [translate]="'DISCONNECTED.TEST.NET'"></div>
              <i class="icon-check"></i>
            </div>
          </div>
        </div>
      }
  
    </div>
  }
</div>